import React from 'react'
import { BottomArroe, Chat, Divider, DownIcon, Like, Report } from '../utils/icons'
import { Avatar } from 'antd'
import female1 from '../assets/images/Female11.png'

function ReadCourseForum() {
    return (
        <div className='space-y-5'>
            <div className='flex justify-between items-center'>
                <h1 className='font-semibold text-lg'>Read Course Forum</h1>
                <button className='flex items-center gap-2 text-sm'>Show Details <DownIcon /></button>
            </div>
            <h1 className='font-semibold text-lg'>Responses ( 277 )</h1>
            <input placeholder='What Are your thoughts ....' className='shadow-inputSHadow p-3 w-full rounded-3xl outline-none placeholder:text-xs' />
            {[...Array(3)].map((_, i) => {
                return <div key={i} className='space-y-5 p-5'>
                    <div className='flex gap-3 items-center'>
                        <Avatar size={'large'} shape='square' src={female1} alt='female1' />
                        <div>
                            <h1 className='font-semibold'>Faisal Fahd</h1>
                            <p className='text-xs'>about 10 days ago</p>
                        </div>
                    </div>
                    <p>Hello everyone! I'm thrilled to be taking this class along side all of you. I'm a complete newbie to this field and want to learn more about interface design and even delve into the mechanics of user research and testing</p>
                    <div className='flex justify-between'>
                        <div className='flex gap-5'>
                            <button className='flex items-center gap-2 text-sm text-darkOrange'>Like <Report /></button>
                            <button className='flex items-center gap-2 text-sm text-darkOrange'>Reply <Chat /></button>
                            <button className='flex items-center gap-2 text-sm text-darkOrange'>Report <Like /></button>
                        </div>
                        <button className='flex items-center gap-2 text-sm text-darkOrange'>20 reply </button>
                    </div>
                    <div className='my-10 flex justify-center'>
                        <Divider />
                    </div>
                </div>
            })}
        </div>
    )
}

export default ReadCourseForum